<app-special-investment-table
  [currentTabname]="tabName"
  [prevDocumentType]="prevDocumentType"></app-special-investment-table>
